import { AnyAction } from 'redux';
import { put, take, race } from 'redux-saga/effects';

import * as actions from '@/store/actions';
import { apiClient, throwSubmissionError } from '@/utils';
import { AxiosResponse } from 'axios';
import { WebhookSettingsResponse } from '@/types';


export function* fetchWebhookSettings(action: AnyAction) {
    try {
        const response: AxiosResponse<WebhookSettingsResponse> = yield apiClient.get('/webhook/settings');

        yield put(actions.FETCH_WEBHOOK_SETTINGS.success(response.data));
    } catch (error) {
        yield put(actions.FETCH_WEBHOOK_SETTINGS.failure(error));
    }
}

export function* editWebhookSettings({ payload }: AnyAction) {
    try {
        const response: AxiosResponse<WebhookSettingsResponse> = yield apiClient.put('/webhook/settings', payload);

        yield put(actions.EDIT_WEBHOOK_SETTINGS.success(response));
    } catch (initialError) {
        const { licenseCreated, trialCreated } = yield race({
            licenseCreated: take(actions.CREATE_COMPANY_LICENSE.SUCCESS),
            trialCreated: take(actions.ADD_TRIAL.SUCCESS),
            modalClosed: take(actions.HIDE_LICENSES_MODAL),
        });

        if (licenseCreated || trialCreated) {
            try {
                const response: AxiosResponse<WebhookSettingsResponse> = yield apiClient.put('/webhook/settings', payload);
                yield put(actions.EDIT_WEBHOOK_SETTINGS.success(response));
                yield put(actions.FETCH_WEBHOOK_SETTINGS.success(response.data));
            } catch (error) {
                yield put(actions.EDIT_WEBHOOK_SETTINGS.failure(throwSubmissionError(error)));
            }
        } else {
            yield put(actions.EDIT_WEBHOOK_SETTINGS.failure(throwSubmissionError(initialError)));
        }
    }
}


export function* testWebhook({ payload }: AnyAction) {
    const action = actions.TEST_WEBHOOK;

    try {
        const response: AxiosResponse = yield apiClient.post(`/webhook/endpoints/${payload.Id}/test`);
        yield put(action.success(response.data));
    } catch (error) {
        yield put(action.failure(throwSubmissionError(error)));
    }
}

